import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
export const getKeywords = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  try {
    var _data$keywords;
    const data = await DomainsApiClient.fetch.listKeywords({
      httpClient,
      request: {
        limit: request.limit
      }
    });
    return {
      keywords: (data == null || (_data$keywords = data.keywords) == null || (_data$keywords = _data$keywords.map(_ref2 => {
        let keyword = _ref2.keyword;
        return keyword;
      })) == null ? void 0 : _data$keywords.filter(keyword => keyword !== undefined)) ?? []
    };
  } catch (e) {
    return {
      keywords: []
    };
  }
};
//# sourceMappingURL=getKeywords.js.map